var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPending)?_c('loader',{staticClass:"c-loader"}):_c('div',[(!_vm.products.length)?_c('no-results'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"c c-product-overview__grid"},_vm._l((_vm.products),function(product){return _c('product',{key:product.id,attrs:{"product":product}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }